import styled from 'styled-components'

import { COLOURS, BREAKPOINTS } from 'resources'
import { walletHeaderScribble, walletHeaderScribbleSm } from 'resources/images'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${COLOURS.black};
  background-image: url(${walletHeaderScribbleSm});
  background-size: auto 50%;
  background-repeat: no-repeat;
  background-position: 0% 100%;

  @media (min-width: ${BREAKPOINTS.lg}) {
    min-height: 290px;
    background-size: auto 65%;
    background-image: url(${walletHeaderScribble});
    background-position: 50% 0%;
  }
  @media (min-width: ${BREAKPOINTS.xl}) {
    min-height: 330px;
    background-size: auto 70%;
  }
`

export const Content = styled.div`
  margin: auto 0 0;
`

export const Title = styled.div`
  font-family: 'Druk', sans-serif;
  font-size: 12vw;
  line-height: 1;
  color: ${COLOURS.white};
  text-align: center;

  @media (min-width: ${BREAKPOINTS.sm}) {
    font-size: 70px;
  }

  @media (min-width: ${BREAKPOINTS.md}) {
    font-size: 80px;
  }

  @media (min-width: ${BREAKPOINTS.lg}) {
    font-size: 85px;
    text-align: left;
  }
`

export const Subtitle = styled.div`
  font-family: 'Druk', sans-serif;
  font-size: 30px;
  line-height: 1;
  color: ${COLOURS.white};
  text-align: center;

  @media (min-width: ${BREAKPOINTS.lg}) {
    font-size: 35px;
    text-align: left;
  }
`

export const AccentText = styled.span`
  color: ${COLOURS.systemYellow1};
`
